import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';

import Toggle from 'react-toggle';
import {SketchPicker} from 'react-color';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class ScheduleInitialsEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: '',
      name: '',
      fullname: '',
      description: '',
      color: '',
      background: '',
      diaria: 0,
      is_crew: 0,
      training: 0,
      trip_extra: 0,
      official: 0,
      apresentacao: 0,
      vacant: 0,
      vacation: 0,
      daily_planning: 0,
      stand_by: 0,
      reserve: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleChangeCompleteColor = this.handleChangeCompleteColor.bind(this);
    this.handleChangeCompleteBackground = this.handleChangeCompleteBackground.bind(this);

    this.locale = getLocale();

    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleChangeCompleteColor (color, event) {
    var color = color.hex;
    this.setState({ color: color });
  };

  handleChangeCompleteBackground (color, event) {
    var color = color.hex;
    this.setState({ background: color });
  };


  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/sigla/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            name: responseJson.data.name,
            fullname: responseJson.data.fullname,
            description: responseJson.data.description,
            diaria: responseJson.data.diaria,
            is_crew: responseJson.data.is_crew,
            training: responseJson.data.training,
            trip_extra: responseJson.data.trip_extra,
            official: responseJson.data.official,
            apresentacao: responseJson.data.apresentacao,
            vacant: responseJson.data.vacant,
            vacation: responseJson.data.vacation,
            daily_planning: responseJson.data.daily_planning,
            stand_by: responseJson.data.stand_by,
            reserve: responseJson.data.reserve,
            color: responseJson.data.color,
            background: responseJson.data.background,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      fullname: this.state.fullname,
      description: this.state.description,
      diaria: this.state.diaria,
      is_crew: this.state.is_crew,
      training: this.state.training,
      trip_extra: this.state.trip_extra,
      official: this.state.official,
      apresentacao: this.state.apresentacao,
      vacant: this.state.vacant,
      vacation: this.state.vacation,
      daily_planning: this.state.daily_planning,
      stand_by: this.state.stand_by,
      reserve: this.state.reserve,
      color: this.state.color,
      background: this.state.background,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/sigla', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Siglas.EditarSigla.titulo}</h3>
      <Link to="/siglas" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.Sigla}:</label>
              <input type="text" name="name" className="form-control" placeholder="Sigla" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.NomeInteiro}:</label>
              <input type="text" name="fullname" className="form-control" placeholder="Nome inteiro" value={this.state.fullname} onChange={this.handleChange.bind(this, 'fullname')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.Descricao}:</label>
              <input type="text" name="description" className="form-control" value={this.state.description} onChange={this.handleChange.bind(this, 'description')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.ContaDiaria}?</label>
              <br/>
              <Toggle
                checked={this.state.diaria}
                aria-label='No label tag'
                name="diaria"
                onChange={this.handleToggleChange.bind(this, 'diaria')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.TripulaAeronave}?</label>
              <br/>
              <Toggle
                checked={this.state.is_crew}
                aria-label='No label tag'
                name="is_crew"
                onChange={this.handleToggleChange.bind(this, 'is_crew')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.SiglaDeTreinamento}?</label>
              <br/>
              <Toggle
                checked={this.state.training}
                aria-label='No label tag'
                name="training"
                onChange={this.handleToggleChange.bind(this, 'training')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.SiglaDeTripulacaoExtra}?</label>
              <br/>
              <Toggle
                checked={this.state.trip_extra}
                aria-label='No label tag'
                name="trip_extra"
                onChange={this.handleToggleChange.bind(this, 'trip_extra')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.SiglaDeFerias}?</label>
              <br/>
              <Toggle
                checked={this.state.vacation}
                aria-label='No label tag'
                name="vacation"
                onChange={this.handleToggleChange.bind(this, 'vacation')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.SiglaDeFolga}?</label>
              <br/>
              <Toggle
                checked={this.state.vacant}
                aria-label='No label tag'
                name="vacant"
                onChange={this.handleToggleChange.bind(this, 'vacant')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.SiglaDeApresentacao}?</label>
              <br/>
              <Toggle
                checked={this.state.apresentacao}
                aria-label='No label tag'
                name="apresentacao"
                onChange={this.handleToggleChange.bind(this, 'apresentacao')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.SiglaOficialASerUsadaEmEscala}?</label>
              <br/>
              <Toggle
                checked={this.state.official}
                aria-label='No label tag'
                name="official"
                onChange={this.handleToggleChange.bind(this, 'official')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.SiglaOficialASerUsadaNaEscalaDiaria}?</label>
              <br/>
              <Toggle
                checked={this.state.daily_planning}
                aria-label='No label tag'
                name="daily_planning"
                onChange={this.handleToggleChange.bind(this, 'daily_planning')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.SiglaDeSobreaviso}?</label>
              <br/>
              <Toggle
                checked={this.state.stand_by}
                aria-label='No label tag'
                name="stand_by"
                onChange={this.handleToggleChange.bind(this, 'stand_by')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.SiglaDeReserva}?</label>
              <br/>
              <Toggle
                checked={this.state.reserve}
                aria-label='No label tag'
                name="reserve"
                onChange={this.handleToggleChange.bind(this, 'reserve')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.SelecioneACorDeFundo}:</label>
              <br/>
              <SketchPicker
                color={this.state.background}
                onChangeComplete={this.handleChangeCompleteBackground}
                width={300}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Siglas.EditarSigla.formulario.SelecioneACorDaFonte}:</label>
              <br/>
              <SketchPicker
                color={this.state.color}
                onChangeComplete={this.handleChangeCompleteColor}
                width={300}
              />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvarEdicao}</button>
        </div>

      </form>
    </div>
  </div>
</div>
    );
  }
}

export default ScheduleInitialsEdit;



// WEBPACK FOOTER //
// ./src/Components/ScheduleInitials/ScheduleInitialsEdit.js